import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { renderPageWithSidebarTemplate } from "../../../../utils";

import {
    ueberblickTab,
    anwendungenTab,
    lieferumfangTab,
    zubehoerTab,
    technischeDatenTab,
} from "./tab-contents";

export default {
    title: "Website/Page Templates/Integration Examples/Tabs",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

const Template = (args = { isSourceCode: false }) => {
    return html`
        ${args.isSourceCode
            ? html``
            : html`<div class="row">
                  <div class="gr-12 no-gutter ux-u-margin-bottom-60"></div>
              </div>`}
        <div class="row">
            <div
                class="gr-10 push-1 gr-12@t push-0@t gr-12@m push-0@m ux-u-margin-top-40 ux-u-margin-xl-top-60"
            >
                <ux-tab-container fix-to-top scroll-when-activated>
                    <ux-tab name="Production Status" tab-id="tabOverview">
                        <div
                            class="ux-u-margin-vertical-40 ux-u-margin-l-top-50"
                        >
                            ${args.isSourceCode
                                ? html`Content of the tab here`
                                : html`${ueberblickTab()}`}
                        </div>
                    </ux-tab>
                    <ux-tab name="Production" tab-id="tabApplications">
                        <div
                            class="ux-u-margin-vertical-40 ux-u-margin-l-top-50"
                        >
                            ${args.isSourceCode
                                ? html`Content of the tab here`
                                : html`${anwendungenTab()}`}
                        </div>
                    </ux-tab>
                    <ux-tab name="Lieferumfang" tab-id="tabDeliveryScope">
                        <div
                            class="ux-u-margin-vertical-40 ux-u-margin-l-top-50"
                        >
                            ${args.isSourceCode
                                ? html`Content of the tab here`
                                : html`${lieferumfangTab()}`}
                        </div>
                    </ux-tab>
                    <ux-tab name="Zubehör" tab-id="tabAccessories">
                        <div
                            class="ux-u-margin-vertical-40 ux-u-margin-l-top-50"
                        >
                            ${args.isSourceCode
                                ? html`Content of the tab here`
                                : html`${zubehoerTab()}`}
                        </div>
                    </ux-tab>
                    <ux-tab name="Technische Daten" tab-id="tabTechData">
                        <div
                            class="ux-u-margin-vertical-40 ux-u-margin-l-top-50"
                        >
                            ${args.isSourceCode
                                ? html`Content of the tab here`
                                : html`${technischeDatenTab()}`}
                        </div>
                    </ux-tab>
                </ux-tab-container>
            </div>
        </div>
    `;
};

export const Default = () => renderPageWithSidebarTemplate(() => Template());

const TemplateAnchorNavigation = (args = { isSourceCode: false }) => {
    return html`
        <div style="padding: 60px; background: #c6d4dd;">
            <h2 class="ux-u-text-align--center">
                Top Content
            </h2>
        </div>
        <div class="row">
            <div
                class="gr-10 push-1 gr-12@t push-0@t gr-12@m push-0@m ux-u-margin-top-40 ux-u-margin-xl-top-60"
            >
                <ux-tab-container
                    fix-to-top
                    anchor-navigation
                    scroll-when-activated
                >
                    <ux-tab name="Production Status" tab-id="tabOverview">
                        <div
                            class="ux-u-margin-vertical-40 ux-u-margin-l-top-50"
                        >
                            ${args.isSourceCode
                                ? html`Content of the tab here`
                                : html`${ueberblickTab()}`}
                        </div>
                    </ux-tab>
                    <ux-tab name="Production" tab-id="tabApplications">
                        <div
                            class="ux-u-margin-vertical-40 ux-u-margin-l-top-50"
                        >
                            ${args.isSourceCode
                                ? html`Content of the tab here`
                                : html`${anwendungenTab()}`}
                        </div>
                    </ux-tab>
                    <ux-tab name="Lieferumfang" tab-id="tabDeliveryScope">
                        <div
                            class="ux-u-margin-vertical-40 ux-u-margin-l-top-50"
                        >
                            ${args.isSourceCode
                                ? html`Content of the tab here`
                                : html`${lieferumfangTab()}`}
                        </div>
                    </ux-tab>
                    <ux-tab name="Zubehör" tab-id="tabAccessories">
                        <div
                            class="ux-u-margin-vertical-40 ux-u-margin-l-top-50"
                        >
                            ${args.isSourceCode
                                ? html`Content of the tab here`
                                : html`${zubehoerTab()}`}
                        </div>
                    </ux-tab>
                    <ux-tab name="Technische Daten" tab-id="tabTechData">
                        <div
                            class="ux-u-margin-vertical-40 ux-u-margin-l-top-50"
                        >
                            ${args.isSourceCode
                                ? html`Content of the tab here`
                                : html`${technischeDatenTab()}`}
                        </div>
                    </ux-tab>
                </ux-tab-container>
            </div>
        </div>
    `;
};

export const AnchorNavigation = () =>
    renderPageWithSidebarTemplate(() => TemplateAnchorNavigation());
